import { objectProto } from '../context'
const { toString: nativeObjectToString } = objectProto
export default nativeObjectToString
